import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import api from "../api.js";
import { openSavedReport } from "../lib/generateReport.js";
import { TEST_BUILD } from "../lib/testBuild.js";

export default function ScanSavedPanel({ documentId, isCentral, onNextPatient }) {
  const [document, setDocument] = useState(null);
  const [error, setError] = useState("");
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = () => api.getDocument(documentId).then(value => {
      if (active) { setDocument(value); setError(""); }
      if (isCentral || value.syncedAt) clearInterval(timer);
    }).catch(() => { if (active) setError("Не удалось проверить синхронизацию. Проверим ещё раз автоматически."); });
    const timer = setInterval(refresh, 10000);
    refresh();
    return () => { active = false; clearInterval(timer); };
  }, [documentId, isCentral]);

  const getLink = async () => {
    setBusy(true); setError(""); setCopied(false);
    try {
      const result = await api.getPublicLink(documentId);
      setLink(result.url);
      try { await navigator.clipboard.writeText(result.url); setCopied(true); } catch { /* The selectable link remains available. */ }
    } catch (err) { setError(err.response?.data?.error || "Не удалось получить ссылку. Попробуйте ещё раз."); }
    finally { setBusy(false); }
  };

  return <div className="shrink-0 px-5 py-3 bg-emerald-50 border-b border-emerald-200">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div>
        <p className="text-sm font-semibold text-emerald-900">Обследование сохранено</p>
        <p className="text-xs text-emerald-800">
          {TEST_BUILD ? "Сохранено в отдельной тестовой базе на этом Mac." : isCentral ? "Сохранено на сервере." : document?.syncedAt ? "Сохранено на устройстве и синхронизировано с сервером." : "Сохранено на устройстве. Ожидается синхронизация с сервером."}
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" disabled={!document?.reportHtml} onClick={() => openSavedReport(document.reportHtml)}>Открыть отчёт</Button>
        <Button size="sm" variant="outline" title={TEST_BUILD ? "Публичные ссылки отключены в изолированной тестовой сборке" : !isCentral && !document?.syncedAt ? "Ссылка будет доступна после синхронизации" : undefined} disabled={TEST_BUILD || busy || (!isCentral && !document?.syncedAt)} onClick={getLink}>{busy ? "Получаем ссылку..." : copied ? "Ссылка скопирована" : "Ссылка на отчёт"}</Button>
        <Button size="sm" onClick={onNextPatient}>Следующий пациент</Button>
      </div>
    </div>
    <p className="mt-1 text-[11px] text-slate-500">Сохранение обследования не подтверждает отправку отчёта и оплаты в YClients.</p>
    {link && <input aria-label="Ссылка на отчёт" readOnly value={link} onFocus={event => event.target.select()} className="mt-2 w-full rounded border bg-white px-2 py-1 text-xs" />}
    {error && <p role="alert" className="mt-2 text-xs text-amber-800">{error}</p>}
  </div>;
}
